/* eslint-disable @next/next/no-sync-scripts */
/* eslint-disable react/no-danger */
// import './base.module.css';
import React from "react";
import { seoBaseMin } from "../../utils/stylesUtil/seoBase";
import { flightInlinceCss } from "../../utils/stylesUtil/flightsInline";
import { seoFlightsCss } from "../../utils/stylesUtil/seoFlights";
import { seoFlightMobCss } from "../../utils/stylesUtil/seoFlightMob";
import { footerMobCss } from "../../utils/stylesUtil/footerMobCss";

export const appendHead = (data) => {
  const { appConfig = {}, initial_css: initialCss, device, isGoibibo = false } = data || {};
  let cssPath;
  let jsPath;
  // let imagePath;
  // let minExt;
  const isDesktop = device === "desktop";
  let serverCssPath = "";
  if (appConfig.liveMode) {
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
    jsPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js`;
    serverCssPath = "https://jsak.mmtcdn.com/flights/server";
    // imagePath = `${appConfig.imagePath}/images`;
    // minExt = '.min';
  } else {
    cssPath = "http://localhost:3000/_next/static/css";
    jsPath = "http://localhost:3000/_next/static/js";
    serverCssPath = "http://localhost:8000/build/server";
    // imagePath = '/images';
    // minExt = '';
  }
  const seoBase = seoBaseMin;
  const flightsInline = flightInlinceCss;
  const seoFlights = seoFlightsCss;
  const seoFlightsMob = seoFlightMobCss;
  const script = `
  $(document).ready(function(){
    setTimeout(function(){
      $(".offersType li").click(function(e){
          e.preventDefault();
          var $this = $(this);
          $this.addClass('active');
          $this.addClass('active').siblings().removeClass('active');
          $(".allOffers").removeClass('active').hide();
          var k=$(this).children('a').attr('href');
          $(k).addClass('active').show();
          if ($this.hasClass('active')){
              $(".allOffers.active").fadeIn("slow");
          }
      });
    }, 1000);
  });
  `;

  return (
    <>
      <link href="https://imgak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="http://imgak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://jsak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://cssak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://bid.g.doubleclick.net" rel="preconnect" crossOrigin />
      <link href="http://makemytrip.tt.omtrdc.net" rel="preconnect" crossOrigin />
      {isGoibibo ? (
        <link href={`${cssPath}/dweb-header.min.css`} rel="stylesheet" />
      ) : (
        <link href={`${cssPath}/header.min.css`} rel="stylesheet" />
      )}
      <style dangerouslySetInnerHTML={{ __html: seoBase }} />
      <style dangerouslySetInnerHTML={{ __html: flightsInline }} />
      {isDesktop ? (
        <style dangerouslySetInnerHTML={{ __html: seoFlights }} />
      ) : (
        <style dangerouslySetInnerHTML={{ __html: seoFlightsMob }} />
      )}
      {!isDesktop ? <style dangerouslySetInnerHTML={{ __html: footerMobCss }} /> : null}
      <script type="text/javascript" src="https://code.jquery.com/jquery-3.5.1.min.js" />
      <script src="https://code.jquery.com/ui/1.13.2/jquery-ui.min.js" />
      <script type="text/javascript" src={`${jsPath}/jquery-ui-flights.min.js`} />
      <link rel="stylesheet" href={`${serverCssPath}${initialCss}`} />
      <script defer dangerouslySetInnerHTML={{ __html: script }} type="text/javascript" />
      {/* <script defer type="text/javascript" src={`${srcWidget}`} /> */}
    </>
  );
};
